window.addEventListener('load', function () {
  const recommendationsContainers = document.querySelectorAll("[data-recommendations='container']");
  if (!recommendationsContainers || !recommendationsContainers.length) return;
  recommendationsContainers.forEach(renderProductRecommendations);
});

async function renderProductRecommendations(container) {
  const promise = await attemptFetch('fetching related products', container.dataset.url);
  if (!promise) return;
  const html = await promise.text();
  if (html == 404) {
    console.error('Error on product recommendations (product or section not found): ', html);
    return;
  }
  if (html == 422) {
    console.error('Error on product recommendations (invalid request parameter): ', html);
    return;
  }
  const temp = document.createElement('div');
  temp.innerHTML = html;
  const recommendationsList = container.querySelector("[data-recommendations='list']");
  const recommendationsProducts = temp.querySelectorAll("[data-recommendations='product']");
  if (recommendationsProducts && recommendationsProducts.length) {
    const allCurrencyOutputs = [];
    recommendationsProducts.forEach((product) => {
      handleRecommendationsProduct(recommendationsList, product);
    });
    if (allCurrencyOutputs.length) {
      document.body.dispatchEvent(
        new CustomEvent('CurrencyConverterUpdate', {
          detail: { outputs: allCurrencyOutputs },
        })
      );
    }
  } else {
    if (container.dataset.intent === 'complementary') {
      container.parentElement.removeChild(container);
    } else {
      container.parentElement.parentElement.removeChild(container.parentElement);
    }
  }
}

function handleRecommendationsProduct(list, product) {
  // get the swiper slider if it exists
  const listSlider = list.querySelector('.swiper');
  // use swiper to append slides when layout is slider, or just append the product cards to the parent element if its a list
  if (product.classList.contains('swiper-slide') && listSlider && listSlider.hasOwnProperty('swiper')) {
    listSlider.swiper.appendSlide(product);
    listSlider.swiper.update();
  } else {
    list.appendChild(product);
  }
  // initialize variant selector
  const variantsSelector = product.querySelector('select[data-variants]');
  if (variantsSelector) {
    initVariantSelector(variantsSelector);
    variantsSelector.parentElement.removeChild(variantsSelector);
  }
}
